module.exports = __webpack_public_path__ + "img/FF_Asset_Info_Web_3.0d096170.png";